// extracted by mini-css-extract-plugin
export default {"wrapper":"noMatchInSection_wrapper__UgyvA","image":"noMatchInSection_image__R65OO","body":"noMatchInSection_body__XHR2R","title":"noMatchInSection_title__E74WG"};